"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import ServerError from "@/components/ui/ServerError";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <ServerError reset={reset} />;
}
